import { render } from "./bottleModel.vue?vue&type=template&id=2148c342&lang=true"
import script from "./bottleModel.vue?vue&type=script&lang=js"
export * from "./bottleModel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__